declare namespace $ {

	type $mol_check_icon__hint_shm_hitalama_app_book_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_hitalama_app_book_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['maps_list_visible'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_app_book_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['Maps_list_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__hint_shm_hitalama_app_book_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_hitalama_app_book_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['projects_list_visible'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_app_book_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['Projects_list_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $shm_hitalama_profile_switch__align_shm_hitalama_app_book_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_profile_switch['align'] >
	>
	type $mol_view__sub_shm_hitalama_app_book_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_app_book_menu_item_content__9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['maps_list_toggle_visible'] >[number]
		,
		$mol_view
	>
	type $shm_hitalama_app_book_menu_item_content__10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app_book['projects_list_toggle_visible'] >[number]
		,
		$mol_view
	>
	export class $shm_hitalama_app_book extends $mol_book2_catalog {
		Maps_list_toggle_icon( id: any): $mol_icon_format_list_bulleted
		Maps_list_toggle( id: any): $mol_check_icon
		maps_list_toggle_visible( id: any): readonly(any)[]
		Projects_list_toggle_icon( id: any): $mol_icon_format_list_bulleted
		Projects_list_toggle( id: any): $mol_check_icon
		projects_list_toggle_visible( id: any): readonly(any)[]
		Foot_profile( ): $shm_hitalama_profile_switch
		Foot_profile_card( ): $mol_view
		maps_list_visible( next?: boolean ): boolean
		projects_list_visible( next?: boolean ): boolean
		menu_item_content( id: any): readonly($mol_view)[]
		menu_body( ): readonly($mol_view)[]
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map